import { TimePicker } from "antd";
import React from "react";

import { TimePickerClock } from "../Icons/TimePickerClock";

const CustomTimePicker = (props) => {
  return (
    <TimePicker
      needConfirm={false}
      format="HH:mm"
      suffixIcon={<TimePickerClock cls={"text-primary"} />}
      minuteStep={15}
      showNow={false}
      placeholder="00:00"
      allowClear={false}
      classNames={{
        popup: {
          root: "custom_time_picker",
        },
      }}
      {...props}
    />
  );
};

export default CustomTimePicker;
